import React from 'react';
import { CrowBeeldkwaliteitScore } from '../../../../common/src/domain/customInspectionTypes/crowBeeldkwaliteit/crowBeeldkwaliteitScore';
import { crowBeeldkwaliteitScoreToColorCode } from '../../../../common/src/domain/customInspectionTypes/crowBeeldkwaliteit/crowBeeldkwaliteitScoreToColorCode';
import { conditionScoreToScore } from '../../../../common/src/domain/customInspectionTypes/crowBeeldkwaliteit/crowBeeldkwaliteitSettings';
// eslint-disable-next-line @typescript-eslint/naming-convention
const CrowBeeldkwaliteitConditionScoreLabel = React.memo((props: { conditionScore: number | undefined | null | string }) => {
    if (props.conditionScore === null || props.conditionScore === undefined) {
        return null;
    }
    const crowScore = conditionScoreToScore(props.conditionScore) as CrowBeeldkwaliteitScore;
    const colorCode = crowBeeldkwaliteitScoreToColorCode(crowScore);

    return (
        <span className="label p5 fs11" style={{ backgroundColor: colorCode }}>
            {crowScore}
        </span>
    );
});

CrowBeeldkwaliteitConditionScoreLabel.displayName = 'Nen3140ConditionScoreLabel';
export { CrowBeeldkwaliteitConditionScoreLabel };
